import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { COLORS } from '../../theme';

const TopBar: React.FC = ({ children }) => {
  return (
    <Box
      sx={{
        width: '100%',
        background: COLORS.brand.white,
        boxShadow: `0px 10px 30px ${alpha(COLORS.gray[850], 0.2)}`,
        padding: '1em',
      }}
    >
      {children}
    </Box>
  );
};

export default TopBar;
